export default class ObjectUtils {

    static getValueOrDefault<T>(value: T | undefined | null, defaultValue: T): T {
        if (value) {
            return value as T;
        } else {
            return defaultValue;
        }
    }
}